import DataLakeService from 'src/modules/dataLake/dataLakeService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'DATALAKE_VIEW';

const dataLakeViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: dataLakeViewActions.FIND_STARTED,
      });

      const record = await DataLakeService.find(id);

      dispatch({
        type: dataLakeViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: dataLakeViewActions.FIND_ERROR,
      });

      getHistory().push('/data-lake');
    }
  },
};

export default dataLakeViewActions;
